/**
 * Stack of `LeadCard` entries with dividers for the responsive leads list.
 *
 * Where: `Leads` page when not using table layout.
 * Uses: `LeadCard` for each `LeadListItem`.
 * Behavior: dividers between items; order matches API list order.
 */
import React from 'react';
import { Stack, Divider } from '@mui/material';
import { LeadCard } from './LeadCard';
import type { LeadListItem } from '@/api/leads';

interface LeadsCardProps {
  items: LeadListItem[];
  onCardClick: (uuid: string) => void;
}

export const LeadsCard: React.FC<LeadsCardProps> = ({ items, onCardClick }) => {
  return (
    <Stack divider={<Divider flexItem />} spacing={0}>
      {items.map((item) => (
        <LeadCard key={item.key} item={item} onCardClick={onCardClick} />
      ))}
    </Stack>
  );
};

